const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.25 6A.75.75 0 0 1 9 5.25h11a.75.75 0 0 1 0 1.5H9A.75.75 0 0 1 8.25 6m-5 12a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75m3.25-6.75a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5z"/></svg>';
export {
  a as w
};
